import { render } from "./Footer.vue?vue&type=template&id=5cfaf738&scoped=true"
import script from "./Footer.js?vue&type=script&lang=js&external"
export * from "./Footer.js?vue&type=script&lang=js&external"

import "./Footer.css?vue&type=style&index=0&id=5cfaf738&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfaf738"]])

export default __exports__